export default __webpack_public_path__ + "static/media/wrd.7c5e2b5d.svg";